import { useState } from "react"
import { Link, NavLink } from "react-router-dom"
import {Menu, X, ArrowUpRight} from 'lucide-react'
import { brandName, calendlyUrl, images, navLinks, practitionerName } from "@/data/site"

function Header() {
  const [open, setOpen] = useState(false)

  return (
    <header className="sticky top-0 z-40 border-b border-[#e5d8cc]/80 bg-[#f7f3ed]/90 backdrop-blur-md transition-all duration-300">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3.5 md:px-8">
        <Link to="/" className="group flex items-center gap-3.5 focus:outline-none" onClick={() => setOpen(false)}>
          <div className="flex h-16 w-16 md:h-20 md:w-20 items-center justify-center overflow-hidden transition-transform duration-300 group-hover:scale-105">
            <img
              src={images.logo}
              alt={brandName}
              className="h-full w-full object-contain"
            />
          </div>
          <span className="block font-display text-xl font-medium tracking-tight text-[#2f241d] transition-colors group-hover:text-[#b85c38] md:text-2xl">
            {brandName}
          </span>
        </Link>

        <nav className="hidden items-center gap-1.5 md:flex" aria-label="Navigation principale">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                `rounded-full px-3.5 py-1.5 text-xs uppercase tracking-[0.15em] font-medium transition-all duration-200 ${
                  isActive
                    ? "bg-[#6f4b3e] text-[#fbf7f2] shadow-sm"
                    : "text-[#5e4b3e] hover:bg-[#ebdcd0]/60 hover:text-[#2f241d]"
                }`
              }
              end={link.to === "/"}
            >
              {link.label}
            </NavLink>
          ))}
          <a
            href={calendlyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group ml-2 inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-[#b85c38] to-[#9e4a29] px-4 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-white shadow-warm-sm transition-all duration-300 hover:shadow-warm-md hover:scale-[1.02] active:scale-[0.98]"
          >
            <span>Prendre RDV</span>
            <ArrowUpRight size={13} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </nav>

        <button
          type="button"
          className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#d8c5b5] bg-[#ebdcd0]/50 text-[#5e4b3e] transition-colors hover:bg-[#ebdcd0] md:hidden"
          onClick={() => setOpen((prev) => !prev)}
          aria-expanded={open}
          aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open ? (
        <div className="border-t border-[#e5d8cc] bg-[#f7f3ed] px-5 py-5 shadow-lg md:hidden">
          <nav className="flex flex-col gap-2" aria-label="Navigation mobile">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-xl px-4 py-2.5 text-xs font-medium uppercase tracking-[0.14em] transition-colors ${
                    isActive ? "bg-[#6f4b3e] text-[#fbf7f2]" : "text-[#5e4b3e] hover:bg-[#ebdcd0]/60"
                  }`
                }
                end={link.to === "/"}
              >
                {link.label}
              </NavLink>
            ))}
            <a
              href={calendlyUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="mt-2 flex items-center justify-center gap-1.5 rounded-xl bg-[#b85c38] px-4 py-3 text-center text-xs font-semibold uppercase tracking-[0.16em] text-white shadow-sm"
            >
              <span>Prendre rendez-vous (Calendly)</span>
              <ArrowUpRight size={14} />
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  )
}

export default Header
